import { useState } from "react";

const useDefaultState = <T>(defaultValue: T) => {
  const [value, setValue] = useState<T>();
  return [value ?? defaultValue, setValue, value !== undefined] as const;
};

export default useDefaultState;
